import { cloneDeep, unset } from 'lodash';
import { IOrganizationProfileStatus } from '../interfaces/organizationProfileNotifications';
export type SectionStatus = [string, boolean | null];
export type RequiredStatusesType = {
  operationDetailsSection: SectionStatus[];
  hiringClientSection: SectionStatus[];
  contactInformationSection: SectionStatus[];
};
export function getRequiredStatuses(
  organizationProfile: IOrganizationProfileStatus,
  aionOperatingRegionsV2: boolean,
  servicesProvidedV2: boolean,
  manageHiringClientConnections: boolean,
  chasOrganizationFields: boolean,
  keysToExclude?: string[]
): RequiredStatusesType {
  const statuses = cloneDeep(organizationProfile);
  if (keysToExclude) {
    keysToExclude.forEach(path => {
      unset(statuses, path);
    });
  }
  const allStatuses = Object.entries(statuses);

  return allStatuses.reduce((result: object, [sectionKey, sectionValue]: any) => {
    result[sectionKey] = Object.entries(sectionValue).filter(([key, value]: [string, boolean | null]) => {
      if (['connectedClientServiceCategories', 'connectedClientIndustries'].includes(key)) return false;
      if (key === 'operationRegionsIsCompleted' && aionOperatingRegionsV2) return false;
      if (key === 'operatingRegionsV2IsCompleted' && !aionOperatingRegionsV2) return false;
      if (['servicesIsCompleted', 'industriesIsCompleted'].includes(key) && servicesProvidedV2) return false;
      if (['serviceCategoriesIsCompleted', 'allServicesMatchBusinessType'].includes(key) && !servicesProvidedV2)
        return false;
      if (
        ['requestConnectionsIsCompleted', 'reviewIncomingIsCompleted'].includes(key) &&
        !manageHiringClientConnections
      )
        return false;
      if (['businessSummaryIsCompleted', 'organizationTypeIsCompleted'].includes(key) && !chasOrganizationFields)
        return false;
      return value !== null;
    });
    // When 'allServicesMatchBusinessType' is false it should replace 'serviceCategoriesIsCompleted'
    if (
      result[sectionKey].find(
        ([key, value]: [string, boolean | null]) => key === 'allServicesMatchBusinessType' && value === false
      )
    ) {
      result[sectionKey] = result[sectionKey].filter(([key]: [string]) => key !== 'serviceCategoriesIsCompleted');
    }
    if (
      result[sectionKey].find(
        ([key, value]: [string, boolean | null]) => key === 'allServicesMatchBusinessType' && value === true
      )
    ) {
      result[sectionKey] = result[sectionKey].filter(([key]: [string]) => key !== 'allServicesMatchBusinessType');
    }
    return result;
  }, {}) as RequiredStatusesType;
}

export function isProfileCompleted(statuses: SectionStatus[]) {
  return !Object.values(statuses).some(([_, value]: SectionStatus) => value === false);
}
